// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@awc/Overrides/Widgets/Brand/BrandList";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, createLinkIconStyles } from "@awc/XDL/Utilities";
import ArrowUp from "@insite/mobius/Icons/ArrowUp";
import { css } from "styled-components";

listStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 48px;
        margin-top: 48px;
    `,
};

listStyles.brandAlphabetSections = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 12px;
        margin-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

listStyles.brandLetter = {
    variant: "h3",
    color: "primary",
    css: css`
        margin-bottom: 0;
        text-transform: uppercase;
    `,
};

listStyles.brandItemsWrapper = {
    gap: 12,
    css: css`
        margin: 0;
        max-width: 100%;
    `,
};

listStyles.brandItem = {
    width: [12, 12, 6, 4, 4],
};

listStyles.backToTopLink = {
    ...createLinkIconStyles({ icon: ArrowUp, linkStyles: { icon: { position: "right" } }, sizeVariant: "medium" }),
};

listStyles.brandLink = {
    typographyProps: {
        lineHeight: fontConfig.lineHeight.singleLineRegular,
        size: fontConfig.fontSize.singleLineRegular,
        weight: fontConfig.weight.regular,
        css: css`
            margin: 0;
        `,
    },
};
